import { RunnerCapability } from "gitpod-next-api/gitpod/v1/runner_pb";
import type { PlainRunner } from "@/queries/runner-queries";

/**
 * Checks if a runner has LLM/agent execution capabilities.
 *
 * @param runner - The runner to check capabilities for
 * @returns true if the runner supports agent execution, false otherwise
 */
export function hasLLMCapabilities(runner?: PlainRunner): boolean {
    if (!runner?.status?.capabilities) {
        return false;
    }

    return runner.status.capabilities.includes(RunnerCapability.AGENT_EXECUTION);
}

/**
 * Checks if a runner supports runner-side agent (RSA) execution.
 */
export function hasRunnerSideAgentCapability(runner?: PlainRunner): boolean {
    if (!runner?.status?.capabilities) {
        return false;
    }

    return runner.status.capabilities.includes(RunnerCapability.RUNNER_SIDE_AGENT);
}
